import { createFileRoute, redirect } from '@tanstack/react-router';
import { setActiveOrgId } from '@/api/axios-instance';
import { SignedInLandingPage } from '@/features/salon-picker/signed-in-landing-page';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context, preload }) => {
    if (!context.auth.isSignedIn) throw redirect({ to: '/login' });
    // The single post-sign-in decision point: the landing picks the salon (or the
    // salon picker / agency) from the person's salons, so no salon is active here —
    // even when Clerk remembers one from the last session. A hover preload is not a visit.
    if (!preload) setActiveOrgId(null);
  },
  component: SignedInLandingPage,
});
